// Shared toast store. One toast surface, one queue — any component can
// fire a notification by calling showToast() without wiring up props or
// events through the tree.
//
// A toast is rendered as `{before} <strong>{emphasis}</strong> {after}`,
// e.g. "Added Word Cloud to My Bookmarks".

import Vue from 'vue'

export type Toast = {
  before: string
  emphasis: string
  after: string
  icon: string
  iconColor?: string
  key: number
}

let nextKey = 0

export const toastStore = Vue.observable({
  current: null as Toast | null,
})

export function showToast(opts: {
  before: string
  emphasis: string
  after?: string
  icon?: string
  iconColor?: string
}): void {
  nextKey++
  toastStore.current = {
    before: opts.before,
    emphasis: opts.emphasis,
    after: opts.after ?? '',
    icon: opts.icon ?? 'check_circle',
    iconColor: opts.iconColor,
    key: nextKey,
  }
}

export function clearToast(): void {
  toastStore.current = null
}
